import type { ThemeMode } from '@stores/themeStore'
import { useThemeStore } from '@stores/themeStore'

const themes: { value: ThemeMode; label: string; icon: string }[] = [
  { value: 'light', label: 'Light', icon: '☀️' },
  { value: 'dark', label: 'Dark', icon: '🌙' },
  { value: 'system', label: 'System', icon: '💻' },
]

export default function ThemeToggle() {
  const { mode, setMode } = useThemeStore()

  return (
    <div className="flex items-center gap-2 rounded-lg border border-gray-200 bg-gray-50 p-1 dark:border-gray-700 dark:bg-gray-800">
      {themes.map((theme) => (
        <button
          key={theme.value}
          onClick={() => setMode(theme.value)}
          className={`flex items-center gap-1.5 rounded px-3 py-1.5 text-sm font-medium transition-colors ${
            mode === theme.value
              ? 'bg-white text-gray-900 shadow-sm dark:bg-gray-700 dark:text-white'
              : 'text-gray-600 hover:text-gray-900 dark:text-gray-400 dark:hover:text-gray-200'
          }`}
          title={`Switch to ${theme.label} mode`}
        >
          <span className="text-base">{theme.icon}</span>
          <span className="hidden sm:inline">{theme.label}</span>
        </button>
      ))}
    </div>
  )
}
